import {useAuth} from "./useAuth";

const useIsLoggedIn = () => {
    const { user } = useAuth();
    const localStorageUser = window.localStorage.getItem("user");

    return user &&
        user.firstname !== undefined &&
        user.firstname !== null &&
        user.firstname !== "" &&
        user.emailVerified !== null &&
        localStorageUser !== "{\"theme\":\"light\"}"
}

export default useIsLoggedIn;